<template>
  <div style="width: 100%;height: 100%;position: relative;"
       v-loading="loading" :element-loading-text="loadingText">

    <!--背景图-->
    <div class="imgbanner">
      <img src="/static/img/login/loginBg.png" style="width: 100%;height: 100%" alt="loginBg"/>
    </div>

    <!--内容-->
    <div class="main_bg" v-show="showData">
      <div class="main_div">
        <div class="login_right">
          <div class="form_container">
            <el-form :model="loginForm" ref="loginForm" class="loginform">
              <el-form-item>
                <div class="login_label">用户名</div>
              </el-form-item>
              <el-form-item prop="account">
                <el-input auto-complete="off" v-model="loginForm.account" placeholder="输入用户名" class="login_input">
                  <template slot="prepend">
                    <img src="/static/img/login/login_user.png" border="0" alt=""/>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <div class="login_label">密&nbsp;&nbsp;&nbsp;码</div>
              </el-form-item>
              <el-form-item>
                <el-input auto-complete="off" type="password" v-model="loginForm.password" placeholder="输入密码"
                          @keyup.enter.native="login" class="login_input" :show-password="true">
                  <template slot="prepend">
                    <img src="/static/img/login/login_pass.png" border="0" alt=""/>
                  </template>
                </el-input>
              </el-form-item>
              <Verify
                @success="success"
                :mode="'pop'"
                :captchaType="captchaType"
                :imgSize="{ width: '330px', height: '155px' }"
                ref="verify"
              ></Verify>
              <!--              <el-form-item>-->
              <!--                <div class="login_label">验证码</div>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item>-->
              <!--                  <el-form-item prop="captcha">-->
              <!--                    <el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="输入验证码" class="login_input">-->
              <!--                      <template slot="prepend">-->
              <!--                        <img src="/static/img/login/login_captcha.png" alt="captcha"/>-->
              <!--                      </template>-->
              <!--                      <template slot="append">-->
              <!--                        <img class="input-captcha" :src="loginForm.src" @click="refreshCaptcha" title="单击图片刷新验证码" alt="captcha"/>-->
              <!--                        <Verify-->
              <!--                          @success="success"-->
              <!--                          :mode="'pop'"-->
              <!--                        :captchaType="'blockPuzzle'"-->
              <!--                        :imgSize="{ width: '330px', height: '155px' }"-->
              <!--                        ref="verify"-->
              <!--                        ></Verify>-->
              <!--                        <button @click="useVerify">调用验证组件</button>-->

              <!--                      </template>-->
              <!--                    </el-input>-->
              <!--                  </el-form-item>-->
              <!--              </el-form-item>-->
              <el-form-item>
                <div style="width: 100%;text-align: center">
                  <el-button class="form_button" @click.native.prevent="useVerify">
                    <div class="form_button_container">登 录</div>
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
import {initThemeData} from "../utils/default"
import {initMenuRoutes} from "../router/index";
import store from '@/store'
import Verify from "../components/verifition/Verify";
let myApp;
export default {
  name: 'Login',
  components: {
    ThemePicker,
    LangSelector,
    Verify,

  },
  data() {
    return {
      loading: false,
      showData: true,
      loadingText: '',
      captchaType: 'blockPuzzle',
      loginForm: {
        account: '',
        password: '',
        captcha: '',
        src: ''
      },
      checked: true,
      theme: {},
      appName: '',
    }
  },
  methods: {
    login() {
      if ('' === this.loginForm.account) {
        this.$message({message: '请输入用户名！', type: 'error'});
        return true;
      }
      if ('' === this.loginForm.password) {
        this.$message({message: '请输入密码！', type: 'error'});
        return true;
      }
      // if ('' === this.loginForm.captcha) {
      //   this.$message({message: '请输入验证码！', type: 'error'});
      //   return true;
      // }
      this.loading = true;
      this.loadingText = '登录验证中，请稍候 ... ';

      let userInfo = {
        account: this.loginForm.account,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha
      };
      this.$api.login.login(userInfo).then((res) => {
        if (res.code !== 200) {
          this.$message({
            message: res.msg,
            type: 'error'
          });
          this.loading = false;
          this.refreshCaptcha();

        } else {
          this.loginProcess(userInfo.account, res.data);
        }
      }).catch((res) => {
        this.$message({
          message: res.message,
          type: 'error'
        });
        this.loading = false;
      });
    },
    refreshCaptcha: function () {
      this.loginForm.src = globalConfig.baseUrl + "/system/login/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields();
      this.loginForm.password = '';
    },
    success(params){
      this.login();
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    useVerify(){
      this.$refs.verify.show()
    },
    loginProcess(userName, token) {
      this.loadingText = '验证通过，正在初始化 ... ';

      Cookies.set('token', token); // 放置token到Cookie
      sessionStorage.setItem('token', token); // 保存token到本地会话
      sessionStorage.setItem('user', userName); // 保存用户到本地会话
      window.localStorage.removeItem("projectId");
      this.$store.commit('menuRouteLoaded', false); // 要求重新加载导航菜单

      //加载动态菜单
      this.$api.menu.findNavTree({'userName': userName})
        .then(res => {
          // 保存菜单树
          store.commit('setNavTree', res.data);

          //添加菜单路由--router>index
          initMenuRoutes();
          this.loadingText = '验证通过，初始化完成 ... ';

          //加载权限
          this.$api.user.findPermissions({'loginName': userName}).then(res => {
            // 保存用户权限标识集合
            store.commit('setPerms', res.data)

            this.loadingText = '验证通过，进入首页 ... ';

            setTimeout(function () {
              myApp.$router.push('/')  // 登录成功，跳转到主页
            }, 1000)
          })
        })
    },
  },
  mounted() {
    myApp = this;
    this.appName = globalConfig.appName;

    this.loading = true;
    this.showData = false;

    this.refreshCaptcha();
    this.theme = initThemeData(this.$store.state.app);

    this.loading = false;
    this.showData = true;

    //点击文字验证
    let now = new Date();
    let minutes = now.getMinutes();
    if (minutes % 2 == 0){
      this.captchaType = 'clickWord';
    }
  },
  //回车键登录
  created() {
    let that = this;
    document.onkeypress = function (e) {
      let keycode = document.all ? event.keyCode : e.which;
      if (keycode === 13) {
        if (that.login()) {
          document.onkeypress = undefined;
        }
        return false;
      }
    }
  },
  beforeDestroy(){
    document.onkeypress = function (e) {
      let keycode = document.all ? event.keyCode : e.which;
      if (keycode === 13) {
        return 10;
      }
    }
  }
}
</script>

<style scoped>
body {
  /*background-color: black !important;*/
}
.imgbanner img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.main_bg {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  justify-content: center;
  align-items: center;
  display: flex;
}

.main_div {
  width: 1265px;
  height: 740px;
  position: relative;
  background-image: url("/static/img/login/pannel.png");
}

.login_right {
  width: 400px;
  height:300px;
  margin-top: 210px;
  margin-left: 670px;
  /*background: rgba(44, 22, 254, 0.7);*/
}

.form_container {
  width: 100%;
}

.form_button {
  float: contour;
  border: none;
  color: #FFFFFF;
  padding: 0;
  margin-top: 30px;
  margin-left: 58px;
}

.form_button_container {
  width: 405px;
  height: 59px;
  font-size: 20px;
  letter-spacing: 10px;
  color: white;
  line-height: 59px;
  /*font-weight: 400;*/
  /*border-radius: 6px;*/
  background-image: url("/static/img/login/login_btn.png");
}

.login_label {
  width: 100%;
  height: 25px;
  text-align: left;
  font-size: 18px;
  color: gray;
  margin-left: 60px;
}
.login_input{
  margin-left: 58px;
}

.el-form-item{
  margin-bottom: 12px !important;
}

.form_container /deep/ .el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 0 10px 10px 0;
  border: 1px solid #D1D1D1;
  border-left: none;
  width: 300px;
  background: rgba(243,245,251, 1);
}
.form_container /deep/ .el-input-group__prepend{
  height: 42px !important;
}
.form_container /deep/ .el-input-group__append {
  border: none;
  background:none;
  right: 173px;
  /*padding-top: 1px;*/
}
.form_container /deep/ .el-input__suffix{
  right: 45px;
  margin-top: 2px;
}
.input-captcha{
  width: 152px;
  cursor: pointer;
  height: 42px;
  border-radius: 0px 10px 10px 0px;
  /*margin-top: 1px;*/
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue